import React from "react";
import {autobind} from "core-decorators";
import {observer} from "mobx-react";
import {Button, Col, Modal, Row} from "antd";
import {Link} from "react-router-dom";

import {PiecesQuery} from "@/graphql/types";
import {paths} from "@/routes";
import DownloadButton from "@/components/DownloadButton/DownloadButton";
import StoreContext from "@/stores/StoreContext";

export interface IDownloadPieceModalProps {
  close: () => void;
  open: boolean;
  piece: PiecesQuery["pieces"][0];
}

@autobind
@observer
export default class DownloadPieceModal extends React.Component<IDownloadPieceModalProps> {
  static contextType = StoreContext;
  context!: React.ContextType<typeof StoreContext>;

  downloadMixdown() {
    Modal.info({
      title: "Download mixdown",
      content:
        'You can download an audio file with all the voices by opening the piece, opening the mixer and clicking on the "Download mixdown" button. You will get a file that sounds exactly as when you press play on Cantāmus. This means you can adjust the volume, muting and panning of each voice to create the perfect mix. Besides, you can include the rehearsal voice.',
      onOk() {},
    });
  }

  public render() {
    const {close, piece, open} = this.props;
    const {session} = this.context;
    return (
      <Modal
        className="DownloadPieceModal"
        title="Download piece audios"
        open={open}
        onCancel={close}
        footer={null}
        destroyOnClose={true}
        forceRender={true}
        width={350}
      >
        <Row justify="center" gutter={[0, 8]}>
          {piece.parts.map((part) => (
            <Col key={`${piece.id}-${part.id}`} span={24}>
              <DownloadButton
                url={part.audio}
                filename={part.name}
                text={part.name}
                block
                size="middle"
                type="default"
                shape="default"
              />
            </Col>
          ))}
          <Col span={24}>
            <DownloadButton
              text="Mixdown"
              block
              size="middle"
              type="default"
              shape="default"
              onClick={this.downloadMixdown}
            />
          </Col>
          {session.isEnsembleConductor && (
            <Col span={24}>
              <Link to={paths.virtualChoir(piece.id)}>
                <Button block size="middle">
                  Create Virtual Choir Mixdown
                </Button>
              </Link>
            </Col>
          )}
        </Row>
        <Row style={{marginTop: 20, textAlign: "justify"}}>
          <p style={{fontSize: 12}}>
            Notice: you can share the rendered vocal audio tracks for non-commercial personal use, including sharing it
            on social media, providing credit to Cantamus as follows: “
            <strong>
              Audio tracks generated with <a href="https://cantamus.app/">Cantamus</a> software
            </strong>
            ”.
          </p>
          <p style={{fontSize: 10, textDecoration: "italic"}}>
            For any commercial or electronic distribution use, please contact us at:{" "}
            <a href="mailto:info@cantamus.app" style={{textDecoration: "underline"}}>
              info@cantamus.app
            </a>{" "}
            for obtaining an appropriate license. You can check our{" "}
            <a
              href="https://s3-eu-west-1.amazonaws.com/media.voctrolabs/trompa/cantamus-legal/Cantamus-Terms%20of%20Use.pdf"
              style={{textDecoration: "underline"}}
            >
              Terms of Use
            </a>{" "}
            for more details about the media content copyright.
          </p>
        </Row>
      </Modal>
    );
  }
}
